import { Component, input } from '@angular/core';

@Component({
	selector: 'external-link-icon',
	templateUrl: './external-link-icon.html',
	standalone: true
})
export class ExternalLinkIconComponent {
	color = input<string>('#000000');
	size = input<number>(16);
}

